import React from 'react';
import { useNavigate } from 'react-router-dom';

const Failed = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h1 style={styles.alert}>ACCESS DENIED</h1>
      <p style={styles.text}>
        THE GATEKEEPER HAS DETERMINED YOU ARE NOT READY.
      </p>
      <p style={styles.subtext}>
        This Protocol requires absolute focus. Come back when you are serious about changing your life.
      </p>
      <button onClick={() => navigate('/')} style={styles.button}>RETURN TO BASE</button>
    </div>
  );
};

const styles = {
  container: { background: '#000', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff', textAlign: 'center', padding: '20px' },
  alert: { color: 'red', fontFamily: 'Orbitron', fontSize: '3rem', letterSpacing: '5px', borderBottom: '2px solid red', paddingBottom: '20px' },
  text: { fontFamily: 'Courier New', marginTop: '40px', fontSize: '1.2rem' },
  subtext: { color: '#666', maxWidth: '600px', margin: '20px auto', fontFamily: 'Inter' },
  button: { marginTop: '50px', background: 'transparent', border: '1px solid #444', color: '#888', padding: '15px 40px', cursor: 'pointer', fontFamily: 'Orbitron' }
};

export default Failed;
